import { render } from "./SupplierListPage.vue?vue&type=template&id=a03625cc&scoped=true&ts=true"
import script from "./SupplierListPage.vue?vue&type=script&lang=ts"
export * from "./SupplierListPage.vue?vue&type=script&lang=ts"

import "./SupplierListPage.vue?vue&type=style&index=0&id=a03625cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03625cc"]])

export default __exports__